import { topics } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';

const stats = [
  { value: '12,684', label: '累计存档条目' },
  { value: '554', label: '整理专题数' },
  { value: '7 年', label: '最早回溯年份' },
];

export default function TopicStrip() {
  return (
    <section id="topics" className="border-b border-background-200/70 bg-background-50">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-6 md:py-16 lg:px-10">
        <SectionHeading
          kicker="黑料整理"
          title="按题材收拢的整理专题"
          desc="与其零散翻找，不如从题材入口进入。每个专题都持续维护，新物料会补进对应的时间线。"
          accent="accent"
          action={{ label: '全部专题', href: '#topics' }}
        />

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-12 lg:gap-6">
          <Reveal className="lg:col-span-4">
            <div className="flex h-full flex-col justify-between rounded-lg border border-accent-200 bg-accent-50 p-5 md:p-6">
              <div>
                <h3 className="font-heading text-xl font-bold leading-snug text-accent-950">
                  为什么要把黑料整理成专题
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                  单纯的爆料清单看久了会乱。我们把记录按题材归并、按时间排序，让同一条线索的来龙去脉留在同一页，
                  查黑料存档时不用来回跳。
                </p>
              </div>
              <div className="mt-6 grid grid-cols-3 gap-3">
                {stats.map((stat) => (
                  <div key={stat.label}>
                    <div className="font-heading text-xl font-bold text-accent-700 md:text-2xl">
                      {stat.value}
                    </div>
                    <div className="mt-1 text-xs text-foreground-600">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-8 lg:grid-cols-3">
            {topics.map((topic, index) => (
              <Reveal key={topic.name} delay={index * 50}>
                <a
                  href="#compilation"
                  className="group flex h-full cursor-pointer flex-col rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-secondary-400 hover:bg-secondary-50"
                >
                  <div className="flex items-center justify-between">
                    <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                      <i className={`${topic.icon} text-lg`}></i>
                    </span>
                    <span className="font-heading text-lg font-bold text-foreground-400">
                      {topic.count}
                    </span>
                  </div>
                  <h3 className="mt-4 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-secondary-700">
                    {topic.name}
                  </h3>
                  <p className="mt-1.5 flex-1 text-xs leading-relaxed text-foreground-600">
                    最新：{topic.latest}
                  </p>
                  <span className="mt-3 flex items-center gap-1 text-xs text-foreground-500 transition-colors group-hover:text-secondary-700">
                    进入专题
                    <i className="ri-arrow-right-s-line"></i>
                  </span>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}